// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3eL2f","selected":"Chip_selected__2SN9i"};